import React, { useContext } from 'react';
import { ApiContext } from 'common/src/contexts/ApiContext';

export default function withApi(WrappedComponent) {
  return function WithApi(props) {
    const api = useContext(ApiContext);
    return <WrappedComponent {...{ ...props, api }} />;
  };
}
